import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import './global.css';

const deployEnv = import.meta.env.VITE_DEPLOY_ENV ?? 'development';

Sentry.init({
  dsn: 'https://e685090e63bc0f54802d80f4cce243d0@o4505950121164800.ingest.us.sentry.io/4511275633803264',
  // sendDefaultPii captures cookies, HTTP headers, user IPs, and request bodies.
  // Deliberately enabled for debugging in this tax application — reviewed and approved
  // with data governance. Sentry is only active in staging/production (see `enabled` below).
  sendDefaultPii: true,
  environment: deployEnv,
  enabled: deployEnv === 'production' || deployEnv === 'staging',
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in document');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
